import { css } from "../../../../../styled-system/css";

export const styles = {
  wrapper: () =>
    css({
      position: "relative",
      maxWidth: "560px",
      width: "100%",
      aspectRatio: "16 / 9",
      overflow: "hidden",
      "& iframe": {
        position: "absolute",
        top: "0",
        left: "0",
        bottom: "0",
        right: "0",
        width: "100%",
        height: "100%",
        border: "none",
      },
    }),
};
